import React from "react"
import { Toast, ToastBody } from "reactstrap"

import Spinners from "components/Common/Spinner"

import deleteRed from "../../../assets/images/icons/delete-red.svg"
import close from "../../../assets/images/icons/close.svg"
import toast from "react-hot-toast"
import BgPatternImage from "../../../assets/images/background-pattern.png"

function RejectConfirmationModal({
  id,
  open,
  setOpen,
  isLoading,
  title = "Reject Request",
  description = "Are you sure you want to reject request?",
  onReject,
  onSuccess,
  onClose,
}) {
  const handleDelete = async () => {
    try {
      const { success, message } = await onReject({ id }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toastMessage" })
      }
    } catch (error) {
      console.error("Delete failed", error)
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }
  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3 delete-tost"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <div className="delete-card-wrapper">
              <div className="inner-box danger">
                <i className="mdi mdi-close-circle-outline"></i>
              </div>
              <div>
                <h4>{title}</h4>
                {description}
              </div>
              <div className="close-icon" onClick={() => setOpen(false)}>
                <img src={close} alt="" />
              </div>
            </div>
            <div className="mt-3 pt-3 button-wrapper position-relative z-2">
              <button
                onClick={() => onClose()}
                type="button"
                className="cancel"
              >
                Cancel
              </button>
              <button type="button" className="delete" onClick={handleDelete}>
                {isLoading ? <Spinners /> : "Reject Request"}
              </button>
            </div>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default RejectConfirmationModal
